import { render, staticRenderFns } from "./ReceiveUserForm.vue?vue&type=template&id=2c6cbdd4&scoped=true"
import script from "./ReceiveUserForm.vue?vue&type=script&lang=js"
export * from "./ReceiveUserForm.vue?vue&type=script&lang=js"
import style0 from "./ReceiveUserForm.vue?vue&type=style&index=0&id=2c6cbdd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cbdd4",
  null
  
)

export default component.exports